// extracted by css-extract-rspack-plugin
export default {"cls1":"RadarNavButton-cls1_1zD","cls2":"RadarNavButton-cls2_SiD RadarNavButton-cls1_1zD"};